import { Box, Tag, Title } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import {
  FinanceValueObjectsJournalDraftEntryStatusEnum,
  FinanceValueObjectsJournalEntryStatusEnum,
  FinanceValueObjectsJournalEntryTypeEnum,
  JournalEntryFragment,
} from 'generated/resources/graphql'

import DayPicker from 'modules/core/components/DayPicker'
import TextField from 'modules/core/components/TextField'
import { dateBackendToUI, dateUIToBackend } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import CurrencySelector from 'modules/finance/components/CurrencySelector'
import { mapStatusColor, mapStatusName, mapTypeText } from 'modules/finance/lib/journalEntries'

import { JournalDraftEntryFormValues } from './form'

interface JournalEntryDataProps {
  disabled?: boolean
  form?: FormikProps<JournalDraftEntryFormValues>
  journalEntry?: JournalEntryFragment | null
  type: FinanceValueObjectsJournalEntryTypeEnum
  currency: string
  legalEntityName: string
  status?:
    | FinanceValueObjectsJournalEntryStatusEnum
    | FinanceValueObjectsJournalDraftEntryStatusEnum
}

const extractDateValue = (date: string | undefined) =>
  date !== undefined && date !== '' ? dateBackendToUI(date) : ''

export const JournalEntryData = ({
  disabled = false,
  form,
  journalEntry,
  type,
  currency,
  legalEntityName,
  status,
}: JournalEntryDataProps) => {
  return (
    <Box gap="s16">
      <Box flexDirection="column" justifyContent="spaceBetween" gap="s16">
        <Box flexDirection="row" alignItems="center" gap="s8">
          <Tag showCircle type={mapStatusColor(status)}>
            {mapStatusName(status)}
          </Tag>
        </Box>
        <Title variant="400" title={i18n.t('finance.journal_entry.data.title')} />
      </Box>
      <Box flexDirection="row" gap="s24">
        <TextField
          readonly
          label={i18n.t('finance.journal_entry.data.type.label')}
          value={mapTypeText(type)}
        />
        <DayPicker
          readonly={disabled}
          label={i18n.t('finance.journal_entry.data.reference_date')}
          placeholder={i18n.t('finance.invoices.detail.placeholders.document_date')}
          value={extractDateValue(form?.values.referenceDate || journalEntry?.referenceDate)}
          onChange={(value) =>
            form?.setValues({ ...form.values, referenceDate: dateUIToBackend(value) })
          }
          error={form?.errors.referenceDate}
        />
      </Box>
      <Box flexDirection="row" gap="s24">
        <TextField
          readonly
          label={i18n.t('finance.journal_entry.data.legal_entity')}
          value={legalEntityName}
        />
        <CurrencySelector value={currency ?? ''} isDisabled />
      </Box>
      <TextField
        readonly={disabled}
        label={i18n.t('finance.journal_entry.data.description')}
        placeholder={!disabled ? i18n.t('finance.journal_entry.data.description') : ''}
        value={form?.values.description || journalEntry?.description || ''}
        onChange={(value) => form?.setValues({ ...form.values, description: value })}
      />
    </Box>
  )
}
